
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import Layout from "../layout"

const Profile = () => {    
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const mobile = useSelector(state => state.mobile);

    useEffect(() => {
        document.title = 'Профиль | Личный кабинет Брокера THE FIVE';
    }, [])

    console.log(auth)
    
    return (
        <Layout>
            <div className="profile">
                {!mobile && <div className="title">ПРОФИЛЬ</div>}
                <div className="subtitle">Основная информация</div>
                <div className="profile-info">
                    <div className="profile-info__item">
                        <div>
                            <div className="profile-info__title">ФИО</div>
                            <div className="profile-info__text">{auth.user.fio}</div>
                        </div>
                        <div>
                            <div className="profile-info__title">Телефон</div>
                            <div className="profile-info__text profile-info__text_small">{auth.user.phone}</div>
                        </div>
                    </div>
                    <div className="profile-info__item">
                        <div>
                            <div className="profile-info__title">Должность</div>
                            <div className="profile-info__text">{auth.user.position}</div>
                        </div>
                        <div>
                            <div className="profile-info__title">Электронная почта</div>
                            <div className="profile-info__text profile-info__text_small">{auth.user.email}</div>
                        </div>
                    </div>
                </div>
                <div className="subtitle">Информация о компании</div>
                <div className="profile-info">
                    <div className="profile-info__item">
                        <div>
                            <div className="profile-info__title">Организационно-правовая форма</div>
                            <div className="profile-info__text profile-info__text_small">{auth.user.legalType}</div>
                        </div>
                        <div>
                            <div className="profile-info__title">Юридическое название</div>
                            <div className="profile-info__text">{auth.user.legalName}</div>
                        </div>
                        <div>
                            <div className="profile-info__title">Брендовое название</div>
                            <div className="profile-info__text">{auth.user.brandName}</div>
                        </div>
                    </div>
                    <div className="profile-info__item">
                        <div>
                            <div className="profile-info__title">Город ведения деятельности</div>
                            <div className="profile-info__text profile-info__text_small">{auth.user.city}</div>
                        </div>
                        <div>
                            <div className="profile-info__title">ИНН</div>
                            <div className="profile-info__text profile-info__text_small">{auth.user.inn}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Profile